import { render, staticRenderFns } from "./ProductQuickAddModal.vue?vue&type=template&id=64b8047c&scoped=true"
import script from "./ProductQuickAddModal.vue?vue&type=script&lang=js"
export * from "./ProductQuickAddModal.vue?vue&type=script&lang=js"
import style0 from "./ProductQuickAddModal.vue?vue&type=style&index=0&id=64b8047c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b8047c",
  null
  
)

export default component.exports